// extracted by mini-css-extract-plugin
export default {"root":"QuoteItem__root--UC7yH","left":"QuoteItem__left--xl45M","row-title":"QuoteItem__row-title--UrMUP","rowTitle":"QuoteItem__row-title--UrMUP","right":"QuoteItem__right--ihjlS"};